<div style="height: 500px; width: 100%;"
     leaflet
     [leafletOptions]="options"
     [leafletLayers]="layers"
     (leafletMapReady)="onMapReady($event)">
</div>
